// src/browser.ts
export * from "./core/types";
export * from "./core/constants";
export * from "./core/errors";
export { Logger } from "./core/logger";

export { initLogger, getLogger, createLogger } from "./init";

// Create and export default logger instance
import { getLogger } from "./init";
export const logger = getLogger();
